export function subcategoryUrl(destination, current) {
  const existing = new URL(current);
  const target = new URL(destination, existing.origin);
  target.search = '';
  for (const [name, value] of existing.searchParams) {
    if (name === 'sort_by' || name.startsWith('filter.')) {
      target.searchParams.append(name, value);
    }
  }
  return target.href;
}

if (typeof document !== 'undefined') {
  const navigation = document.querySelector('[data-cb-subcategories]');
  if (navigation) {
    const refreshLinks = () => {
      navigation.querySelectorAll('[data-cb-subcategory-link]').forEach((link) => {
        link.href = subcategoryUrl(link.dataset.categoryUrl, window.location.href);
      });
    };
    refreshLinks();
    // Dawn updates price/sort filters without reloading this navigation.
    // Refresh before mouse, keyboard or modified-click navigation.
    navigation.addEventListener('pointerdown', refreshLinks);
    navigation.addEventListener('focusin', refreshLinks);
    navigation.addEventListener('click', refreshLinks);
    window.addEventListener('popstate', refreshLinks);
  }
}
